import { render } from "./cd-ceiling.vue?vue&type=template&id=4881c5bc"
import script from "./cd-ceiling.vue?vue&type=script&lang=js"
export * from "./cd-ceiling.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__